var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { class: _vm.$.top_row }, [
      _c(
        "div",
        { style: { width: "210px" } },
        [
          _c("vgp-label-slot", {
            attrs: { label: _vm.locales("pricing_widget_user_select_label") },
            scopedSlots: _vm._u([
              {
                key: "body",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { class: _vm.$.users_selection },
                      [
                        _c("dropdown-select", {
                          attrs: {
                            "drop-list": _vm.dropdownItems,
                            selected: _vm.selectedItem,
                            multiselect: false,
                            "show-reset-btn": false,
                            "show-selected-first": false,
                            "fixed-width": 280,
                            "item-template": "text",
                            "track-by-text": "text",
                            "group-by": "discountGroup",
                            "group-settings": {
                              divider: false,
                              color: "#808080",
                            },
                            "left-icon": {
                              name: "team",
                              type: "regular",
                              size: 20,
                            },
                          },
                          on: {
                            selected: function (selected) {
                              return _vm.$emit("changeUserCount", selected[0])
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm.isShowUsersSelectionNotify
                          ? _c("div", {
                              class: _vm.$.users_selection_notify,
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.locales(
                                    "payment_user_selection_notification_for_large_teams"
                                  )
                                ),
                              },
                              on: { click: _vm.onShowContactForm },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: [_vm.$.swith, _vm.isAnnual ? _vm.$.annual : _vm.$.month] },
        [
          _c(
            "div",
            {
              class: [_vm.$.tab, _vm.$.annually],
              on: {
                click: function ($event) {
                  return _vm.$emit("toggleAnnual", true)
                },
              },
            },
            [
              _c(
                "div",
                { class: [_vm.$.save_item, _vm.isAnnual ? _vm.$.dnone : ""] },
                [_c("discount-svg")],
                1
              ),
              _vm._v(" "),
              _c("div", [_vm._v(_vm._s(_vm.locales("plans_annually_locale")))]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: [_vm.$.tab, _vm.$.monthly],
              on: {
                click: function ($event) {
                  return _vm.$emit("toggleAnnual", false)
                },
              },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.locales("plans_monthly_locale")) +
                  "\n      "
              ),
            ]
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { class: _vm.$.plan_cards },
      _vm._l(_vm.plans, function (plan, index) {
        return _c("payment-plan-card", {
          key: index,
          ref: "card",
          refInFor: true,
          attrs: {
            "plan-data": plan,
            "is-annual": _vm.isAnnual,
            "is-popup": _vm.isPopup,
            heights: _vm.cardSectionsHeights,
          },
          on: {
            buyPlanClick: function (plan) {
              return _vm.$emit("buyPlanClick", plan)
            },
            upgradePlanClick: function (plan) {
              return _vm.$emit("upgradePlanClick", plan)
            },
            setHeights: _vm.setHeights,
          },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }